// Optional side-channel: no global 401 redirect can interrupt a recording.
import axios from "axios";

export const gameRequest = async (path, data, method = "GET") => {
  const token = localStorage.getItem("tw1_token");
  const response = await axios({
    url: `${process.env.REACT_APP_BACKEND_URL}/api${path}`,
    method, data, timeout: 7000,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const gameError = (error) => typeof error?.response?.data?.detail === "string"
  ? error.response.data.detail : "Dit lukt nu niet. Probeer het later opnieuw.";